import { Component, OnInit, ViewChild } from '@angular/core';
import { LoginViewComponent } from '../../../shared/components/login/login-view/login-view.component';
import { ActivatedRoute, Router } from '@angular/router';
import { VillaCollectionContainer } from '../villa-collection.container';
import { FilterPipe } from '../../../shared/pipes/filter.pipe';
import { HotelPreview } from '../../results/results.container';
import { IMarker } from '../../../shared/components/map/map.component';
import { Title} from '@angular/platform-browser';



@Component({
  selector: 'app-villa-results',
  templateUrl: './villa-results.component.html',
  styleUrls: ['./villa-results.component.css']
})
export class VillaCollectionComponent implements OnInit {

    allFacilities = new Array();
    facilityGroupsFlat = new Array();
    userLogged$;
    @ViewChild('loginModal') loginModal: LoginViewComponent;
    filtersVisible: boolean;
    requestId: string;
    isRequestOpen = false;
    hotelTypes: Array<string>;
    mealTypes: Array<string>;
    exclusiveCategories: Array<string>;
    optionalFacilities: Array<string>;
    personalRequest: boolean;
    lightbox: boolean;
    filters;
    offerFilters;
    offers: Array<any>;
    hotel: Array<any>;
    zoomInfo = 8;
        mapCenter = {latitude: 35.0564782, longitude: 24.2646407 };
        selectedHotel = null;
        openHotelPopup = false;

    userSignup = {email: null, name: null, surname: null, passwd: null, confirmedPassword: null};

    hotelPreviews: Array<HotelPreview>;
    markers: Array<IMarker>;

    hotelPreviewCollection: Array<any>;
    updated;


    stickySidebar = {stickySidebarEnabled: false,   top: '', width: 300, position: '', bottom: '' };
    topValue;

    totalNumberofPages = 0;
    pagesLoaded = 1;

    loadingResults = false;

    constructor(
        private route:  ActivatedRoute,
        private villaCollectionContainer: VillaCollectionContainer,
        private titleService: Title,
        private router: Router
    ) {
        this.filtersVisible = false;
        // this.hotelTypes = this.villaCollectionContainer.hotelTypes$;
        this.filters = {
            hotelTypes: new Array(),
            mealTypes: new Array(),
            exclusiveCategories: new Array(),
            optionalFacilities: new Array(),
            priceRange: new Array()
        };
        this.hotelPreviews = new Array<HotelPreview>();
        // this.hotelPreviewsOffers = new Array<HotelPreview>();
        this.markers = new Array<IMarker>();
   }

   ngOnInit() {
        // f clear array to avoid adding duplicates
        this.hideBookInfo();
        this.hideVillaName();
        this.titleService.setTitle('Villa Collection' + ' ' + '|' + ' ' + 'Vervendo.com');
        this.villaCollectionContainer.getHotelPreviews().splice(0);
        this.villaCollectionContainer.retrieveVillaPreviewCollection(0, 36);
        this.filters.offerType = 'Hotel';
        this.offerFilters = JSON.parse(JSON.stringify(this.filters));
        this.offerFilters.offerType = 'Offer';
        this.villaCollectionContainer.hotelPreviewsArr$.subscribe(hotelPreviews => {
            console.log('loading previews: ' + hotelPreviews.length);
            this.hotelPreviews = hotelPreviews;
        });
    }

    goToSearch() {
        this.router.navigate(['/search']);
    }

    toggleFilterOptions() {
        this.filtersVisible = !this.filtersVisible;
    }


    filterResults(event) {
        const filterType = event[0];
        const filters = event[1];
        this.filters = filters;
        this.offerFilters = this.filters;
        this.offerFilters = JSON.parse(JSON.stringify(this.filters));
        this.offerFilters.offerType = 'Offer';
        this.updated = new Date();
    }


    getMealTypes = () => this.villaCollectionContainer.mealTypes$;
    getHotelTypes = () => this.villaCollectionContainer.hotelTypes$;

  loadMore() {
    this.loadingResults = true;
    this.pagesLoaded++;
    this.villaCollectionContainer.retrieveVillaPreviewCollection((this.pagesLoaded - 1) * 36, 36);
    this.loadingResults = false;
  }

  hideBookInfo() {
    const w = document.getElementById('bookInfo');
    if (w) {
        w.style.visibility = 'hidden';
    }
}

hideVillaName() {
    const r = document.getElementById('headerSortig');
    if (r) {
        r.style.visibility = 'hidden';
    }
}

getPropertyButton() {

    const x = document.getElementById('property');
}

}
